<template>
  <div class="links">
    <router-link
    class="links__item"
    :to="{ name: PATHS_NAME.CALENDAR }"
    :class="route.name === PATHS_NAME.CALENDAR ? 'links__item--active' : ''"
    :tabindex="route.name === PATHS_NAME.CALENDAR ? -1 : 0">
      <CalendarIcon class="links__icon" /> Календарь
    </router-link>
    <router-link
    class="links__item"
    :to="{name: PATHS_NAME.FORECASTERS}"
    :class="route.name === PATHS_NAME.FORECASTERS ? 'links__item--active' : ''"
    :tabindex="route.name === PATHS_NAME.FORECASTERS ? -1 : 0">
      <ForecasterIcon class="links__icon" /> Форкастеры
    </router-link>
    <router-link
    class="links__item"
    :to="{name: PATHS_NAME.SIGNALS}"
    :class="route.name === PATHS_NAME.SIGNALS ? 'links__item--active' : ''"
    :tabindex="route.name === PATHS_NAME.SIGNALS ? -1 : 0">
      <SignalIcon class="links__icon" /> Сигналы
    </router-link>
    <router-link
    class="links__item"
    :to="{name: PATHS_NAME.SCANNER}"
    :class="route.name === PATHS_NAME.SCANNER ? 'links__item--active' : ''"
    :tabindex="route.name === PATHS_NAME.SCANNER ? -1 : 0">
      <ScreanerIcon class="links__icon" /> Скринер
    </router-link>
    <router-link
    class="links__item"
    :to="{name: PATHS_NAME.POLYMARKET}"
    :class="route.name === PATHS_NAME.POLYMARKET ? 'links__item--active' : ''"
    :tabindex="route.name === PATHS_NAME.POLYMARKET ? -1 : 0">
      <PolymarketIcon class="links__icon" /> Предикшены
    </router-link>
  </div>
</template>

<script setup>
  import { useRoute } from 'vue-router';
  import { PATHS_NAME } from "@shared/routers/consts/pathsName";
  //-----------------------
  import CalendarIcon from '@shared/UI/SVG/navigation/CalendarIcon.vue';
  import ForecasterIcon from '@shared/UI/SVG/navigation/ForecasterIcon.vue';
  import SignalIcon from '@shared/UI/SVG/navigation/SignalIcon.vue';
  import ScreanerIcon from "@svg/navigation/ScreanerIcon.vue";
  import PolymarketIcon from '@shared/UI/Svg_new/context/Polymarket.vue';
  //-----------------------
  const route = useRoute();
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>
